import { CONTENT_GROUP_ACTION } from "../constants";

const initialState = {
  isInvalidStageModalOpen: false,
  data: null, // {cards: []} // List of tracked cards that are preventing the action
};

export const invalid_stage_popup = (state = initialState, action) => {
  switch (action.type) {
    case CONTENT_GROUP_ACTION.OPEN_INVALID_STAGE_MODAL:
      return {
        ...state,
        isInvalidStageModalOpen: true,
        data: action.payload,
      };
    case CONTENT_GROUP_ACTION.CLOSE_INVALID_STAGE_MODAL:
      return {
        ...state,
        isInvalidStageModalOpen: false,
        data: null,
      };
    default:
      return state;
  }
};